import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-ink text-sand pt-24 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-sand/10">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-6 max-w-sm text-sand/70 leading-relaxed">
              Servicii IT integrate pentru afaceri și case. Echipă dedicată,
              garanție reală.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-2 text-2xl font-display font-bold text-sand hover:text-clay transition-colors group"
            >
              Lucrează cu noi
              <ArrowUpRight size={22} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </Link>
          </div>

          <FooterCol
            title="Navigare"
            links={[
              ["Acasă", "/"],
              ["Servicii", "/servicii"],
              ["Contact", "/contact"],
            ]}
          />

          <FooterCol
            title="Servicii"
            links={[
              ["Reparații PC & Laptop", "/servicii"],
              ["Rețele & Internet", "/servicii"],
              ["Camere de supraveghere", "/servicii"],
              ["Web design & hosting", "/servicii"],
              ["Suport IT firme", "/servicii"],
            ]}
          />

          <div className="md:col-span-2">
            <div className="overline text-sand/50">CONTACT</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a href="tel:+40799301302" data-testid="footer-phone" className="hover:text-clay transition-colors">
                  0799 301 302
                </a>
              </li>
              <li>
                <a href="mailto:contact@itview.ro" data-testid="footer-email" className="hover:text-clay transition-colors">
                  contact@itview.ro
                </a>
              </li>
              <li className="text-sand/60">On-site & remote</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-sand/50">
          <p>© {year} ITView · itview.ro · Toate drepturile rezervate.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-sand">Termeni</a>
            <a href="#" className="hover:text-sand">Confidențialitate</a>
            <a href="#" className="hover:text-sand">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div className="md:col-span-2">
      <div className="overline text-sand/50">{title}</div>
      <ul className="mt-4 space-y-2 text-sm">
        {links.map(([label, href]) => (
          <li key={label + href}>
            <Link to={href} className="text-sand/80 hover:text-clay transition-colors">
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
